import { render, staticRenderFns } from "./EditLandingPlaces.vue?vue&type=template&id=75565700&scoped=true"
import script from "./EditLandingPlaces.vue?vue&type=script&lang=js"
export * from "./EditLandingPlaces.vue?vue&type=script&lang=js"
import style0 from "./EditLandingPlaces.vue?vue&type=style&index=0&id=75565700&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75565700",
  null
  
)

export default component.exports